module.exports = __webpack_public_path__ + "img/金字編輯icon.ae9d1147.svg";